module.exports = __webpack_public_path__ + "static/media/IdProof1.574e9352.svg";